module.exports = __webpack_public_path__ + "img/av.4942dce2.svg";